<script setup>
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency'

defineProps({
  events: { type: Array, default: () => [] }
})

const { t } = useI18n()
const { formatDateTime } = useCurrency()

const labelFor = (kind) => t(`inbox.activity.kinds.${kind}`)
const dotFor   = (kind) => {
  if (kind === 'taken')    return 'var(--accent)'
  if (kind === 'released') return 'var(--muted)'
  if (kind === 'resolved') return 'var(--ok)'
  if (kind === 'assigned') return 'var(--warn)'
  return 'var(--inkSoft)'
}
</script>

<template>
  <section class="rounded-[var(--radius-lg)] border border-[color:var(--line)] p-3">
    <h3 class="text-xs font-semibold uppercase tracking-wider text-[color:var(--muted)] mb-2">
      {{ t('inbox.activity.title') }}
    </h3>
    <p
      v-if="events.length === 0"
      class="text-xs text-[color:var(--muted)]"
    >
      {{ t('inbox.activity.empty') }}
    </p>
    <ul
      v-else
      class="space-y-2"
    >
      <li
        v-for="e in events"
        :key="e.id"
        class="flex items-start gap-2 text-xs"
      >
        <span
          class="mt-1.5 inline-block w-1.5 h-1.5 rounded-full shrink-0"
          :style="{ background: dotFor(e.kind) }"
        />
        <div class="min-w-0 flex-1">
          <div class="flex items-baseline justify-between gap-2">
            <span class="fw-value text-[color:var(--ink)]">{{ labelFor(e.kind) }}</span>
            <span class="text-[10px] text-[color:var(--muted)] shrink-0">{{ formatDateTime(e.created_at) }}</span>
          </div>
          <div class="text-[color:var(--muted)] truncate">
            {{ e.user_name || t('inbox.activity.system') }}
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>
